var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEipsEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3464_927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3464_927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75093 22.2263H10.9766L18.5274 14.6754L17.3018 13.4498L9.75093 21.0006V22.2263ZM22.2701 13.406L18.5493 9.72904L19.775 8.50339C20.1106 8.1678 20.5228 8 21.0116 8C21.5004 8 21.9126 8.1678 22.2482 8.50339L23.4738 9.72904C23.8094 10.0646 23.9845 10.4695 23.9991 10.9437C24.0137 11.418 23.8532 11.8229 23.5176 12.1584L22.2701 13.406ZM8.87546 23.9772C8.62742 23.9772 8.41949 23.8933 8.2517 23.7255C8.0839 23.5577 8 23.3498 8 23.1017V20.6286C8 20.5118 8.02189 20.3987 8.06566 20.2893C8.10943 20.1799 8.17509 20.0814 8.26264 19.9938L17.2799 10.9766L21.0006 14.6973L11.9834 23.7146C11.8958 23.8021 11.7973 23.8678 11.6879 23.9115C11.5785 23.9553 11.4654 23.9772 11.3486 23.9772H8.87546Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEipsEdit);
export default __webpack_public_path__ + "static/media/eipsEdit.0a688fe850657b976fca5d096ed9b029.svg";
export { ForwardRef as ReactComponent };